import React from 'react';
import { CustomizedTypography } from '@components/Customized';
import { RfqDetailData } from '@routes/Common/type';
import { Box, makeStyles } from '@material-ui/core';
import { useStylesCommon } from './useStyles';
import { requestEnumToString } from '@utils/enumToString';
import {
  CapaRfqPcbAssemblyMethodType,
  CapaRfqPcbMaterialSupplyMethodType
} from '@generated/graphql';

const useStyles = makeStyles(() => {
  return {
    dispalayItem: {
      display: 'flex',
      alignItems: 'center',
      '&:not(:first-child)': {
        marginTop: 8
      }
    },
    itemLabel: {
      minWidth: 90,
      marginRight: 16
    },
    itemContent: {
      display: 'flex'
    }
  };
});

interface Props {
  data?: RfqDetailData;
  matches?: boolean;
}

const RfqCircuitAssemblyDetailPresenter: React.FC<Props> = ({
  data,
  matches
}) => {
  const classes = useStyles({ matches: matches });
  const classesCommon = useStylesCommon({ matches: matches });

  return (
    <Box className={classesCommon.root + ' item'}>
      <CustomizedTypography
        variant={'h4'}
        color="textPrimary"
        gutterBottoms={16}
        fontWeight="500"
      >
        조립 정보
      </CustomizedTypography>
      <div className={classes.dispalayItem}>
        <CustomizedTypography
          className={classes.itemLabel}
          variant={'body1'}
          color="textSecondary"
        >
          조립방식
        </CustomizedTypography>
        <CustomizedTypography variant={'body1'} color="textPrimary">
          {data?.pcb?.assemblyMethod
            ?.map((method) =>
              requestEnumToString(
                method.methodType as CapaRfqPcbAssemblyMethodType
              )
            )
            .join(' · ')}
        </CustomizedTypography>
      </div>
      <div className={classes.dispalayItem}>
        <CustomizedTypography
          className={classes.itemLabel}
          variant={'body1'}
          color="textSecondary"
        >
          메탈마스크
        </CustomizedTypography>
        <CustomizedTypography variant={'body1'} color="textPrimary">
          {data?.pcb?.metalMaskAvailablity ? '제공' : '제공 안함'}
        </CustomizedTypography>
      </div>
      <div className={classes.dispalayItem}>
        <CustomizedTypography
          className={classes.itemLabel}
          variant={'body1'}
          color="textSecondary"
        >
          자재
        </CustomizedTypography>
        <CustomizedTypography variant={'body1'} color="textPrimary">
          {requestEnumToString(
            data?.pcb
              ?.materialSupplyMethod as CapaRfqPcbMaterialSupplyMethodType
          )}
        </CustomizedTypography>
      </div>
    </Box>
  );
};

export default RfqCircuitAssemblyDetailPresenter;
